module.exports = __webpack_public_path__ + "img/bx-7.27900b9c.jpg";